module.exports = __webpack_public_path__ + "static/media/error.8ed64696.svg";